var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import Checkbox from '../Checkbox';
import Text from '../Text';
import { debounce } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import colors from '../../themes/colors';
var CheckboxGroupWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
var CheckboxWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 32px;\n  display: flex;\n  align-items: center;\n  width: 140px;\n  cursor: pointer;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 8px;\n\n  transition: border-color 0.15s ease;\n\n  /* resets padding from checkbox icon */\n  & label {\n    margin: 0;\n    & > span {\n      padding: 0 8px 0 0;\n    }\n  }\n\n  ", "\n"], ["\n  height: 32px;\n  display: flex;\n  align-items: center;\n  width: 140px;\n  cursor: pointer;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 8px;\n\n  transition: border-color 0.15s ease;\n\n  /* resets padding from checkbox icon */\n  & label {\n    margin: 0;\n    & > span {\n      padding: 0 8px 0 0;\n    }\n  }\n\n  ", "\n"])), function (_a) {
    var checked = _a.checked, bg = _a.bg;
    return (bg && checked ? colors.neutral20 : colors.neutral60);
}, function (_a) {
    var bg = _a.bg;
    return (bg ? "background-color: ".concat(bg, ";") : '');
});
var debouncer = debounce(function (fn) { return fn(); }, 50);
var CheckboxGroup = function (props) {
    var mounted = useRef(false);
    var selectedDefault = props.selected, onChange = props.onChange, options = props.options, render = props.render;
    var _a = useState(__spreadArray([], (selectedDefault !== null && selectedDefault !== void 0 ? selectedDefault : []), true)), selected = _a[0], setSelected = _a[1];
    var allSelected = options.every(function (_a) {
        var value = _a.value;
        return selected.includes(value);
    });
    var onCheckboxValueChange = function (value) {
        if (selected.includes(value)) {
            setSelected(selected.filter(function (item) { return item !== value; }));
        }
        else {
            setSelected(__spreadArray(__spreadArray([], selected, true), [value], false));
        }
    };
    var onSelectAll = function () {
        if (allSelected) {
            setSelected([]);
        }
        else {
            setSelected(options.map(function (_a) {
                var value = _a.value;
                return value;
            }));
        }
    };
    var onCheckboxWrapperClick = function (value) { return function (e) {
        return debouncer(function () {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            if (value === 'all')
                onSelectAll();
            else
                onCheckboxValueChange(value);
        });
    }; };
    useEffect(function () {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        onChange(selected);
    }, [selected]);
    return (_jsxs(CheckboxGroupWrapper, { children: [_jsx(CheckboxWrapper, __assign({ checked: !allSelected, bg: colors.neutral0, onClick: onCheckboxWrapperClick('all') }, { children: _jsx(Checkbox, { controlled: true, checked: allSelected, onChange: onSelectAll, label: _jsx(Text, __assign({ variant: "tag2Semibold", color: "neutral90" }, { children: "Select all" })), undetermined: true }) })), options.map(function (option, index) {
                var _a;
                var disabled = option.disabled, value = option.value;
                return (_jsx(CheckboxWrapper, __assign({ onClick: onCheckboxWrapperClick(value) }, { children: _jsx(Checkbox, { controlled: true, checked: selected.includes(value), disabled: disabled, variant: "celes", onChange: function () { }, label: (_a = render === null || render === void 0 ? void 0 : render({ value: value, disabled: disabled, index: index })) !== null && _a !== void 0 ? _a : (_jsx(Text, __assign({ variant: "tag2Semibold", color: "neutral90" }, { children: value }))) }) }), value));
            })] }));
};
export default CheckboxGroup;
var templateObject_1, templateObject_2;
